import script from "./TruncatedCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./TruncatedCell.vue?vue&type=script&lang=ts&setup=true"

import "./TruncatedCell.vue?vue&type=style&index=0&id=32b24f0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b24f0e"]])

export default __exports__